import { Identifier } from 'app/shared/storage/services/local-storage.service';
import { UserRoleEnum } from '../models/user-role.enum';
import { CmUser } from '../models/user.model';

export function getAccessToken(): string | null {
  return localStorage.getItem(Identifier.TYPE_TOKEN);
}

export function getCurrentUser(): CmUser | null {
  const userJsonStr = localStorage.getItem(Identifier.TYPE_USER);
  if (userJsonStr) {
    return JSON.parse(userJsonStr);
  } else {
    return null;
  }
}

export function userHasRole(role: UserRoleEnum): boolean {
  const user = getCurrentUser();
  if (user && user.role) {
    return user.role.indexOf(UserRoleEnum[role]) !== -1;
  }
  return false;
}
